var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout help"},[_c('StrapiContent',{attrs:{"strapiUrl":"client-portal-documentations/1"}}),_c('StrapiContent',{attrs:{"strapiUrl":"client-portal-documentations/2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }